<template>
  <div class="flex flex-row items-center gap-2 truncate p-3">
    <RouterLink
      class="flex flex-1 flex-row items-center gap-1.5 truncate"
      :to="{
        name: 'invoice_show_route',
        params: { invoicing_id: invoice.id }
      }"
    >
      <span
        v-if="!invoice.reference"
        class="bg-secondary h-3 w-3 rounded-full"
      ></span>
      <span class="truncate">
        {{ titleValue }}
      </span>
    </RouterLink>
  </div>
</template>
<script>
import DocTypes from '@/assets/enums/invoicing/DocTypes'

export default {
  name: 'InvoiceTitleElement',
  props: {
    column: {
      type: Object,
      required: true
    },
    invoice: {
      type: Object,
      required: true
    },
    displaySubTaskButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['toggle-tasks'],
  computed: {
    docTypeValue() {
      switch (this.invoice.doc_type) {
        case DocTypes.INVOICE:
          return this.$t('attributes.invoice')
        case DocTypes.QUOTE:
          return this.$t('global.quote')
        case DocTypes.CREDIT_NOTE:
          return this.$t('global.credit_note')
        case DocTypes.PURCHASE_ORDER:
          return this.$t('global.purchase_order')
        case DocTypes.INVOICE_PROFORMA:
          return this.$t('global.advance_invoice')
        default:
          return this.$t('global.undefined')
      }
    },
    titleValue() {
      return this.invoice[this.column.field]?.length
        ? this.invoice[this.column.field]
        : this.$t('global.doc_type_to_be_validated', {
            doc_type: this.docTypeValue
          })
    }
  }
}
</script>
